export default [
    {
        tag:         '0.2.8',
        date:        '2019-01-22',
        title:       '0-2-8-title',
        description: '0-2-8-description',
    },
    {
        tag:         '0.2.7',
        date:        '2018-11-26',
        title:       '0-2-7-title',
        description: '0-2-7-description',
    },
    {
        tag:         '0.2.6',
        date:        '2018-11-19',
        title:       '0-2-6-title',
        description: '0-2-6-description',
    },
    {
        tag:         '0.2.5',
        date:        '2018-11-19',
        title:       '0-2-5-title',
        description: '0-2-5-description',
    },
];
